import { render, staticRenderFns } from "./service.vue?vue&type=template&id=1dfd08e4&scoped=true"
import script from "./service.vue?vue&type=script&lang=ts"
export * from "./service.vue?vue&type=script&lang=ts"
import style0 from "./service.vue?vue&type=style&index=0&id=1dfd08e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd08e4",
  null
  
)

export default component.exports